import {Form, Input, Loader, Typography, styled, css} from '@innowise-group/ui-kit';
import {IconContainer} from '@shared/ui-kit/icon/icon.styles';

export const GeotrackContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 15px 16px 16px 16px;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  flex-direction: column;
`;

export const FormLayout = styled(Form.Layout)`
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const FormInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FormContainer = styled(Form.Container)`
  height: auto;
`;

export const Row = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;

export const GeotrackTableContainer = styled.div`
  min-height: 200px;
  display: flex;
  flex-direction: column;
`;

export const SearchInput = styled(Input)`
  background: ${({theme}) => theme.palette.generalAlt.input.background.secondary};
  border: 1px solid ${({theme}) => theme.palette.general.lightGrey[60]};
  border: none;
  &::placeholder {
    font-weight: 500;
    color: ${({theme}) => theme.palette.general.darkGrey[60]};
  }
`;

export const Stat = styled.p`
  display: flex;
  gap: 12px;
  margin: 0;
  color: ${({theme}) => theme.palette.generalAlt.font.secondary};
  font-weight: 400;
  font-size: 11px;
`;

export const FoundEmployeesCount = styled(Typography)`
  align-self: center;
  padding: 12px 24px;
  color: ${({theme}) => theme.palette.general.green[100]};
  font-weight: 500;
  text-align: center;
  border-radius: 16px;
  background-color: ${({theme}) => theme.palette.general.green[20]};
`;

export const FoundRecordsCount = styled(Typography)`
  color: ${({theme}) => theme.palette.general.darkGrey[60]};
  font-weight: 500;
  align-self: center;
`;

export const CenteredContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
`;

export const ExportLoader = styled(Loader)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const AbsoluteAnchor = styled.div`
  height: 0;
  position: relative;
`;

interface HintProps {
  tooltipText: string;
  offset?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const placementMultipliers = {
  top: -1,
  bottom: 1,
  left: -1,
  right: 1,
};

const locateHint = ({offset = 10, placement = 'top'}: Omit<HintProps, 'tooltipText'>) => {
  const isVertical = placement === 'top' || placement === 'bottom';
  const multiplier = placementMultipliers[placement];

  const translations = ['-50%', `calc(${multiplier * 100}% + ${multiplier * offset}px)`];
  if (!isVertical) translations.reverse();

  return css`
    ${isVertical ? 'left' : 'top'}: 50%;
    transform: translate(${translations.join(', ')});
    ${placement}: 0;
  `;
};

export const Hint = styled.div<HintProps>`
  cursor: pointer;
  position: relative;
  width: max-content;
  height: max-content;
  top: 2px;

  &:before {
    transition: opacity 0.25s;
    position: absolute;
    ${locateHint};
    background: ${({theme}) => theme.palette.general.darkGrey[60]};
    color: ${({theme}) => theme.palette.general.lightGrey[20]};
    border-radius: 3px;
    width: 0;
    opacity: 0;
    content: '';
  }

  &:hover:before {
    padding: 5px;
    width: max-content;
    content: '${({tooltipText}) => tooltipText}';
    opacity: 1;
  }

  & > ${IconContainer} {
    margin: 0;
  }
`;

export const SmallLoader = styled(Loader)`
  margin: 8px;
  width: 20px;
  height: 20px;
`;
